document.addEventListener("DOMContentLoaded", function () {

  /* ==========================================
     CONFIGURATION
  ========================================== */

  const SHOP_DOMAIN = "nxtasia.myshopify.com";
  const STOREFRONT_TOKEN = "66c8e65de5b6f3bd03971b69e0ded99a";
  const API_VERSION = "2026-07";

  /*
    Number of results shown to the customer
    on each visible search-results page.
  */
  const RESULTS_PER_PAGE = 12;


  /* ==========================================
   SEARCH TERMINOLOGY ALIASES
========================================== */

/*
  Terms within each group are treated as
  equivalent for search purposes.

  None of these is considered the "primary"
  spelling.

  Example:

  waterproof
  water proof
  water-proof

  all represent the same search intent.
*/

/* ==========================================
   SHARED SEARCH TERMINOLOGY ALIASES
========================================== */

const SEARCH_TERM_GROUPS =
  (
    window.NXTSearchConfig &&
    Array.isArray(
      window.NXTSearchConfig.termGroups
    )
  )
    ? window.NXTSearchConfig.termGroups
    : [];


    /* ==========================================
   SHARED SEARCH STOP WORDS
========================================== */

const SEARCH_STOP_WORDS =
  (
    window.NXTSearchConfig &&
    Array.isArray(
      window.NXTSearchConfig.stopWords
    )
  )
    ? window.NXTSearchConfig.stopWords
    : [];


const SEARCH_STOP_WORD_SET =
  new Set(
    SEARCH_STOP_WORDS.map(
      function (word) {

        return String(word)
          .trim()
          .toLowerCase();

      }
    )
  );


  /* ==========================================
   SHARED FUZZY SEARCH VOCABULARY
========================================== */

const BASE_FUZZY_VOCABULARY =
  Array.isArray(
    window.NXTSearchVocabulary
  )
    ? window.NXTSearchVocabulary
    : [];


/* ==========================================
   NUMERIC UNIT VARIANTS
========================================== */

/*
  Generate equivalent forms of electrical
  ratings only when a number is present.

  This prevents dangerous broad matching such
  as treating every standalone "a" as ampere.

  Examples:

  32A
  32 A
  32 amp
  32 amps
  32 ampere
  32 amperes

  are equivalent.

  Likewise:

  415V / 415 volts
  400Hz / 400 hertz
  70mm² / 70 mm2 / 70 mmsq
*/

function getNumericUnitVariants(term) {

  const value =
    String(term || "").trim();


  /*
    AMPERE
  */

  let match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:a|amp|amps|ampere|amperes)$/i
    );


  if (match) {

    const number =
      match[1];


    return [
      `${number}A`,
      `${number} A`,
      `${number} amp`,
      `${number} amps`,
      `${number} ampere`,
      `${number} amperes`
    ];

  }


  /*
    VOLTAGE
  */

  match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:v|volt|volts)$/i
    );


  if (match) {

    const number =
      match[1];


    return [
      `${number}V`,
      `${number} V`,
      `${number} volt`,
      `${number} volts`
    ];

  }


  /*
    FREQUENCY
  */

  match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:hz|hertz)$/i
    );


  if (match) {

    const number =
      match[1];


    return [
      `${number}Hz`,
      `${number} Hz`,
      `${number} hertz`
    ];

  }


  /*
    CABLE CROSS-SECTIONAL AREA
  */

  match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:mm²|mm2|mmsq)$/i
    );


  if (match) {

    const number =
      match[1];


    return [
      `${number}mm²`,
      `${number} mm²`,
      `${number}mm2`,
      `${number} mm2`,
      `${number}mmsq`,
      `${number} mmsq`
    ];

  }


  return [];
}


/* ==========================================
   SINGULAR / PLURAL WORD VARIANTS
========================================== */

/*
  Generate conservative singular/plural forms
  for ordinary alphabetic search words.

  Examples:

  panel      <-> panels
  socket     <-> sockets
  connector  <-> connectors
  box        <-> boxes
  switch     <-> switches
  battery    <-> batteries

  Technical identifiers are deliberately
  excluded:

  32A
  IP67
  BC1
  SPX4PD1BR
  415V
*/

function getWordFormVariants(term) {

  const original =
    String(term || "").trim();


  if (!original) {
    return [];
  }


  /*
    Only process ONE ordinary alphabetic word.

    Multi-word aliases such as "shore power"
    are already handled by SEARCH_TERM_GROUPS.

    Anything containing numbers, hyphens,
    symbols, etc. is left untouched.
  */

  if (
    !/^[a-z]+$/i.test(original)
  ) {

    return [
      original
    ];

  }


  /*
    Very short words are too ambiguous for
    automatic grammatical transformation.
  */

  if (
    original.length < 4
  ) {

    return [
      original
    ];

  }


  const lower =
    original.toLowerCase();


  const variants =
    new Set([
      original
    ]);


  /* ========================================
     PLURAL -> SINGULAR
  ======================================== */


  /*
    batteries -> battery
    categories -> category

    Require enough letters before "ies" so
    short words do not get transformed
    aggressively.
  */

  if (
    /^[a-z]{3,}ies$/i.test(original)
  ) {

    variants.add(
      original.slice(0, -3) +
      "y"
    );


    return Array.from(variants);

  }


  /*
    boxes    -> box
    switches -> switch
    classes  -> class

    Handle common -es plurals.
  */

  if (
    /(?:ches|shes|xes|zes|sses)$/i.test(
      original
    )
  ) {

    variants.add(
      original.slice(0, -2)
    );


    return Array.from(variants);

  }


  /*
    panels     -> panel
    sockets    -> socket
    connectors -> connector
    plugs      -> plug

    Avoid words whose normal singular form
    already ends in "ss".
  */

  if (
    lower.endsWith("s") &&
    !lower.endsWith("ss") &&
    !lower.endsWith("us") &&
    !lower.endsWith("is")
  ) {

    variants.add(
      original.slice(0, -1)
    );


    return Array.from(variants);

  }


  /* ========================================
     SINGULAR -> PLURAL
  ======================================== */


  /*
    battery -> batteries

    Only consonant + y changes to ies.

    Words such as "relay" become "relays",
    not "relaies".
  */

  if (
    /[^aeiou]y$/i.test(
      original
    )
  ) {

    variants.add(
      original.slice(0, -1) +
      "ies"
    );


    return Array.from(variants);

  }


  /*
    box    -> boxes
    switch -> switches
    class  -> classes
  */

  if (
    /(?:ch|sh|x|z|ss)$/i.test(
      original
    )
  ) {

    variants.add(
      original + "es"
    );


    return Array.from(variants);

  }


  /*
    Regular plural:

    panel     -> panels
    socket    -> sockets
    connector -> connectors
  */

  variants.add(
    original + "s"
  );


  return Array.from(variants);
}


/* ==========================================
   FUZZY SEARCH ELIGIBILITY
========================================== */

function isFuzzyEligibleTerm(term) {

  const value =
    String(term || "")
      .trim()
      .toLowerCase();


  /*
    Minimum length.

    Short words are too ambiguous for safe
    automatic fuzzy matching.
  */

  if (
    value.length < 5
  ) {

    return false;

  }


  /*
    CRITICAL SAFETY RULE:

    Fuzzy matching is permitted only for
    ordinary alphabetic words.

    Therefore all of these are excluded:

    32A
    415V
    IP67
    IK10
    BC1-3403
    model numbers
    hyphenated technical identifiers
  */

  if (
    !/^[a-z]+$/.test(value)
  ) {

    return false;

  }


  /*
    Stop words are never fuzzy targets.
  */

  if (
    SEARCH_STOP_WORD_SET.has(
      value
    )
  ) {

    return false;

  }


  return true;
}


/* ==========================================
   BUILD EFFECTIVE FUZZY VOCABULARY
========================================== */

function buildEffectiveFuzzyVocabulary() {

  const vocabulary =
    new Set();


  /* ========================================
     TITLE-DERIVED VOCABULARY
  ======================================== */

  BASE_FUZZY_VOCABULARY.forEach(
    function (term) {

      const value =
        String(term || "")
          .trim()
          .toLowerCase();


      if (
        isFuzzyEligibleTerm(
          value
        )
      ) {

        vocabulary.add(
          value
        );

      }

    }
  );


  /* ========================================
     TRUSTED SEARCH TERM GROUPS
  ======================================== */

  /*
    Automatically incorporate eligible
    SINGLE-WORD aliases.

    Therefore future additions such as:

    busbar

    automatically become fuzzy-searchable
    without editing search-vocabulary.js.
  */

  SEARCH_TERM_GROUPS.forEach(
    function (group) {

      group.forEach(
        function (term) {

          const value =
            String(term || "")
              .trim()
              .toLowerCase();


          if (
            isFuzzyEligibleTerm(
              value
            )
          ) {

            vocabulary.add(
              value
            );

          }

        }
      );

    }
  );


  return Array.from(vocabulary)
    .sort();
}


const FUZZY_VOCABULARY =
  buildEffectiveFuzzyVocabulary();


  /* ==========================================
   DAMERAU-LEVENSHTEIN DISTANCE
========================================== */

/*
  Measures typing distance between two words.

  Supports:

  - insertion
  - deletion
  - substitution
  - adjacent transposition

  The transposition support is useful for
  common typing mistakes such as:

  panle -> panel
*/

function damerauLevenshtein(
  source,
  target
) {

  const a =
    String(source || "")
      .toLowerCase();

  const b =
    String(target || "")
      .toLowerCase();


  const rows =
    a.length + 1;

  const columns =
    b.length + 1;


  const matrix =
    Array.from(
      {
        length:
          rows
      },
      function () {

        return new Array(
          columns
        ).fill(0);

      }
    );


  for (
    let i = 0;
    i < rows;
    i += 1
  ) {

    matrix[i][0] = i;

  }


  for (
    let j = 0;
    j < columns;
    j += 1
  ) {

    matrix[0][j] = j;

  }


  for (
    let i = 1;
    i < rows;
    i += 1
  ) {

    for (
      let j = 1;
      j < columns;
      j += 1
    ) {

      const substitutionCost =
        a[i - 1] ===
        b[j - 1]
          ? 0
          : 1;


      matrix[i][j] =
        Math.min(

          /*
            Deletion
          */

          matrix[i - 1][j] + 1,


          /*
            Insertion
          */

          matrix[i][j - 1] + 1,


          /*
            Substitution
          */

          matrix[i - 1][j - 1] +
            substitutionCost

        );


      /*
        Adjacent transposition.

        Example:

        panle
        panel
      */

      if (
        i > 1 &&
        j > 1 &&
        a[i - 1] ===
          b[j - 2] &&
        a[i - 2] ===
          b[j - 1]
      ) {

        matrix[i][j] =
          Math.min(
            matrix[i][j],

            matrix[i - 2][j - 2] +
              substitutionCost
          );

      }

    }

  }


  return matrix[
    a.length
  ][
    b.length
  ];
}


/* ==========================================
   FUZZY DISTANCE LIMIT
========================================== */

function getMaximumFuzzyDistance(
  term
) {

  const length =
    String(term || "").length;


  /*
    Under 5 characters:
    fuzzy matching disabled completely.
  */

  if (
    length < 5
  ) {

    return 0;

  }


  /*
    5-7 characters:
    allow only ONE edit.
  */

  if (
    length <= 7
  ) {

    return 1;

  }


  /*
    8-11 characters:
    allow up to TWO edits.
  */

  if (
    length <= 11
  ) {

    return 2;

  }


  /*
    Longer words can tolerate up to
    THREE edits while remaining relatively
    distinctive.
  */

  return 3;
}


/* ==========================================
   FIND FUZZY VOCABULARY MATCH
========================================== */

function findFuzzyVocabularyMatch(
  term
) {

  const input =
    String(term || "")
      .trim()
      .toLowerCase();


  if (
    !isFuzzyEligibleTerm(
      input
    )
  ) {

    return null;

  }


  /*
    If the term is already correctly present
    in our trusted vocabulary, there is
    nothing to correct.
  */

  if (
    FUZZY_VOCABULARY.includes(
      input
    )
  ) {

    return null;

  }


  const maximumDistance =
    getMaximumFuzzyDistance(
      input
    );


  if (
    maximumDistance === 0
  ) {

    return null;

  }


  const candidates = [];


  FUZZY_VOCABULARY.forEach(
    function (candidate) {

      /*
        Cheap length filter before calculating
        the full edit distance.
      */

      if (
        Math.abs(
          candidate.length -
          input.length
        ) >
        maximumDistance
      ) {

        return;

      }


      const distance =
        damerauLevenshtein(
          input,
          candidate
        );


      if (
        distance <=
        maximumDistance
      ) {

        candidates.push({

          term:
            candidate,

          distance:
            distance

        });

      }

    }
  );


  if (
    candidates.length === 0
  ) {

    return null;

  }


  candidates.sort(
    function (a, b) {

      /*
        Lowest edit distance wins.
      */

      if (
        a.distance !==
        b.distance
      ) {

        return (
          a.distance -
          b.distance
        );

      }


      /*
        If edit distance ties, prefer the
        candidate closest in length.
      */

      const aLengthDifference =
        Math.abs(
          a.term.length -
          input.length
        );


      const bLengthDifference =
        Math.abs(
          b.term.length -
          input.length
        );


      if (
        aLengthDifference !==
        bLengthDifference
      ) {

        return (
          aLengthDifference -
          bLengthDifference
        );

      }


      return a.term.localeCompare(
        b.term
      );

    }
  );


  const best =
    candidates[0];


  const secondBest =
    candidates.length > 1
      ? candidates[1]
      : null;


  /*
    AMBIGUITY GUARD

    If two DIFFERENT vocabulary words are
    equally good fuzzy candidates, don't
    guess.

    Example:

    candidate A distance 1
    candidate B distance 1

    -> leave the customer's term untouched.
  */

  if (
    secondBest &&
    secondBest.distance ===
      best.distance
  ) {

    return null;

  }


  return best;
}


/* ==========================================
   GET FUZZY RETRIEVAL VARIANTS
========================================== */

function getFuzzyRetrievalVariants(
  term
) {

  const variants =
    new Set();


  const original =
    String(term || "")
      .trim();


  if (!original) {

    return [];

  }


  /*
    Always preserve the customer's original
    term.
  */

  variants.add(
    original
  );


  const fuzzyMatch =
    findFuzzyVocabularyMatch(
      original
    );


  if (
    fuzzyMatch &&
    fuzzyMatch.term
  ) {

    variants.add(
      fuzzyMatch.term
    );


    /*
      Include singular/plural forms of the
      corrected word.
    */

    getWordFormVariants(
      fuzzyMatch.term
    ).forEach(
      function (wordForm) {

        variants.add(
          wordForm
        );

      }
    );

  }


  return Array.from(variants)
    .filter(Boolean);
}


/* ==========================================
   FUZZY CORRECTED DISPLAY QUERY
========================================== */

/*
  Builds a corrected version of the customer's
  query for DISPLAY PURPOSES ONLY.

  This does not affect retrieval, matching,
  ranking, or the URL.

  Only high-confidence fuzzy vocabulary
  corrections are applied.

  Examples:

  valentiin
    ->
  valentini

  32a conector panle
    ->
  32a connector panel
*/

function getFuzzyCorrectedDisplayQuery(
  query
) {

  const original =
    String(query || "")
      .trim()
      .replace(/\s+/g, " ");


  if (!original) {

    return {
      correctedQuery: original,
      wasCorrected: false
    };

  }


  const words =
    original.split(/\s+/);


  let wasCorrected =
    false;


  const correctedWords =
    words.map(
      function (word) {

        /*
          Preserve punctuation around the
          searchable word.

          Example:

          (conector)
            ->
          (connector)
        */

        const match =
          word.match(
            /^([^a-z0-9]*)([a-z0-9]+)([^a-z0-9]*)$/i
          );


        if (!match) {

          return word;

        }


        const prefix =
          match[1];

        const searchableWord =
          match[2];

        const suffix =
          match[3];


        const fuzzyMatch =
          findFuzzyVocabularyMatch(
            searchableWord
          );


        if (
          !fuzzyMatch ||
          !fuzzyMatch.term
        ) {

          return word;

        }


        const originalNormalized =
          searchableWord.toLowerCase();


        const correctedNormalized =
          fuzzyMatch.term.toLowerCase();


        /*
          No actual spelling correction.
        */

        if (
          originalNormalized ===
          correctedNormalized
        ) {

          return word;

        }


        wasCorrected =
          true;


        return (
          prefix +
          fuzzyMatch.term +
          suffix
        );

      }
    );


  return {
    correctedQuery:
      correctedWords.join(" "),

    wasCorrected:
      wasCorrected
  };
}



/* ==========================================
   CANONICAL NUMERIC UNIT FORM
========================================== */

function getCanonicalNumericUnit(term) {

  const value =
    String(term || "").trim();


  /*
    AMPERE

    32A
    32 amps
    32 ampere

    become:

    32 A
  */

  let match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:a|amp|amps|ampere|amperes)$/i
    );


  if (match) {

    return {
      spaced: `${match[1]} A`,
      compact: `${match[1]}A`
    };

  }


  /*
    VOLTAGE
  */

  match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:v|volt|volts)$/i
    );


  if (match) {

    return {
      spaced: `${match[1]} V`,
      compact: `${match[1]}V`
    };

  }


  /*
    FREQUENCY
  */

  match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:hz|hertz)$/i
    );


  if (match) {

    return {
      spaced: `${match[1]} Hz`,
      compact: `${match[1]}Hz`
    };

  }


  /*
    CABLE CROSS-SECTIONAL AREA
  */

  match =
    value.match(
      /^(\d+(?:\.\d+)?)\s*(?:mm²|mm2|mmsq)$/i
    );


  if (match) {

    return {
      spaced: `${match[1]} mm²`,
      compact: `${match[1]}mm²`
    };

  }


  return null;
}


/* ==========================================
   BUILD SEARCH QUERY VARIANTS
========================================== */

function getSearchQueryVariants(query) {

  const original =
    String(query || "")
      .trim()
      .replace(/\s+/g, " ");


  if (!original) {
    return [];
  }


  /*
    Always preserve the customer's exact query.
  */

  const variants =
    new Set([
      original
    ]);


  /* ========================================
     TERMINOLOGY ALIASES
  ======================================== */

  SEARCH_TERM_GROUPS.forEach(
    function (group) {

      /*
        Find which alias from this group
        appears in the customer's query.
      */

const matchingAlias =
  group
    .slice()
    .sort(
      function (a, b) {

        return b.length - a.length;

      }
    )
    .find(
      function (alias) {

        return containsSearchTerm(
          original,
          alias
        );

      }
    );




      if (!matchingAlias) {
        return;
      }


      /*
        Replace the detected alias with every
        equivalent form in its group.
      */

      group.forEach(
        function (replacement) {

const regex =
  new RegExp(
    `(^|[^a-z0-9])(${escapeRegExp(
      matchingAlias
    )})(?=$|[^a-z0-9])`,
    "gi"
  );


variants.add(
  original.replace(
    regex,
    function (
      match,
      prefix
    ) {

      return (
        prefix +
        replacement
      );

    }
  )
);

        }
      );

    }
  );


  /* ========================================
     NUMERIC UNITS
  ======================================== */

  /*
    Detect number + electrical unit sequences
    anywhere within the query.

    Examples:

    32 amps connector
    connector 415V
    cable 70 mm2
  */

  const unitRegex =
    /(\d+(?:\.\d+)?)\s*(a|amp|amps|ampere|amperes|v|volt|volts|hz|hertz|mm²|mm2|mmsq)\b/gi;


  const unitMatches =
    Array.from(
      original.matchAll(
        unitRegex
      )
    );


  unitMatches.forEach(
    function (unitMatch) {

      const matchedUnit =
        unitMatch[0];


      const unitVariants =
        getNumericUnitVariants(
          matchedUnit
        );


      unitVariants.forEach(
        function (replacement) {

          variants.add(
            original.replace(
              matchedUnit,
              replacement
            )
          );

        }
      );

    }
  );


  /*
    Apply your existing technical
    normalization to every generated query.

    Example:

    400hz -> 400 hz
  */

  Array.from(variants)
    .forEach(
      function (variant) {

        variants.add(
          normalizeSearchQuery(
            variant
          )
        );

      }
    );


  return Array.from(variants)
    .filter(Boolean);
}

/* ==========================================
   EXPAND VARIANTS REPEATEDLY
========================================== */

function expandSearchQueryVariants(query) {

  let variants =
    new Set([
      String(query || "")
        .trim()
        .replace(/\s+/g, " ")
    ]);


  /*
    Run several expansion passes.

    This allows combinations such as:

    singlepole connector 32 amps

    to generate:

    single pole connector 32A
  */

  for (
    let pass = 0;
    pass < 3;
    pass += 1
  ) {

    const currentVariants =
      Array.from(variants);


    currentVariants.forEach(
      function (variant) {

        getSearchQueryVariants(
          variant
        ).forEach(
          function (expanded) {

            variants.add(
              expanded
            );

          }
        );

      }
    );

  }


  /*
    Safety guard.

    Alias combinations can theoretically grow
    quickly. For our controlled dictionary,
    30 variants is plenty.
  */

  return Array.from(variants)
    .filter(Boolean)
    .slice(0, 30);
}


  /*
    Number of candidate results requested
    from Shopify at one time.

    This is NOT the number shown to customers.
  */
  const API_BATCH_SIZE = 250;

  /*
    Safety guard.

    Prevents an extremely broad query from
    causing an excessive number of API calls.
  */
  const MAX_API_BATCHES = 20;

  const endpoint =
    `https://${SHOP_DOMAIN}/api/${API_VERSION}/graphql.json`;


  /* ==========================================
     SEARCH PAGE ELEMENTS
  ========================================== */

  const resultsContainer =
    document.getElementById("custom-search-results");

  const paginationContainer =
    document.getElementById("custom-search-pagination");

  const countContainer =
    document.getElementById("custom-search-count");


  /*
    During the testing stage these containers
    may not exist yet.

    We therefore do NOT stop execution here.
    Retrieval can still be checked in Console.
  */


  /* ==========================================
     GET SEARCH QUERY FROM URL
  ========================================== */

  const params =
    new URLSearchParams(window.location.search);

  const originalQuery =
    (params.get("q") || "").trim();


  if (!originalQuery) {

    if (resultsContainer) {
      resultsContainer.innerHTML =
        "<p>Please enter a search term.</p>";
    }

    return;
  }

  /* ==========================================
   DISPLAY-ONLY FUZZY CORRECTION
========================================== */

const fuzzyDisplayCorrection =
  getFuzzyCorrectedDisplayQuery(
    originalQuery
  );


  /* ==========================================
     NORMALISE TECHNICAL SEARCH TERMS
  ========================================== */

  function normalizeSearchQuery(query) {

    let normalized = query.trim();


    /*
      Frequency

      400hz
      400Hz
      400 hz

      all become:

      400 hz
    */

    normalized = normalized.replace(
      /(\d+)\s*hz\b/gi,
      "$1 hz"
    );


    /*
      Voltage

      28v  -> 28 v
      400v -> 400 v

      IMPORTANT:
      A400 is unaffected because the number
      appears after the letter, not before it.
    */

    normalized = normalized.replace(
      /(\d+)\s*kv\b/gi,
      "$1 kv"
    );

    normalized = normalized.replace(
      /(\d+)\s*v\b/gi,
      "$1 v"
    );


    /*
      Current

      750a -> 750 a
    */

    normalized = normalized.replace(
      /(\d+)\s*ka\b/gi,
      "$1 ka"
    );

    normalized = normalized.replace(
      /(\d+)\s*a\b/gi,
      "$1 a"
    );


    /*
      Power
    */

    normalized = normalized.replace(
      /(\d+)\s*kva\b/gi,
      "$1 kva"
    );

    normalized = normalized.replace(
      /(\d+)\s*kw\b/gi,
      "$1 kw"
    );


    /*
      Cable cross-sectional area

      70mm2 -> 70 mm2
      70mm² -> 70 mm²
    */

    normalized = normalized.replace(
      /(\d+)\s*mm2\b/gi,
      "$1 mm2"
    );

    normalized = normalized.replace(
      /(\d+)\s*mm²/gi,
      "$1 mm²"
    );


    /*
      Collapse accidental multiple spaces.
    */

    normalized = normalized.replace(
      /\s+/g,
      " "
    );


    return normalized.trim();
  }


  const normalizedQuery =
    normalizeSearchQuery(originalQuery);


  /* ==========================================
     TEXT NORMALISATION FOR MATCHING
  ========================================== */

  function normalizeForMatching(text) {

    if (!text) {
      return "";
    }

    return normalizeSearchQuery(
      String(text)
        .replace(/\u00A0/g, " ")
        .replace(/\s+/g, " ")
        .trim()
    ).toLowerCase();
  }


  const matchingQuery =
    normalizeForMatching(originalQuery);

    /* ==========================================
   ALIAS VARIANTS FOR MATCHING
========================================== */

const searchQueryVariants =
  expandSearchQueryVariants(
    originalQuery
  );


const matchingVariants =
  Array.from(
    new Set(
      searchQueryVariants.map(
        function (variant) {

          return normalizeForMatching(
            variant
          );

        }
      )
    )
  )
    .filter(Boolean)
    .sort(function (a, b) {

      /*
        Check longer variants first.

        Example:

        "hazardous area"
        before
        "hazardous"
      */

      return b.length - a.length;

    });

    /* ==========================================
   OPTIMIZED API RETRIEVAL VARIANTS
========================================== */

function getRetrievalQueryVariants(query) {

  const original =
    String(query || "")
      .trim()
      .replace(/\s+/g, " ");


  if (!original) {
    return [];
  }


  /*
    Retrieval variants are deliberately
    different from matching variants.

    Matching/highlighting can understand many
    equivalent forms.

    Shopify only needs a small number of
    strategically useful queries.
  */

  let variants =
    new Set();


  /*
    Always search exactly what the customer
    entered first.
  */

  variants.add(original);


/* ========================================
   TERMINOLOGY ALIASES
======================================== */

SEARCH_TERM_GROUPS.forEach(
  function (group) {

    /*
      Check longer aliases first.

      This ensures that more specific
      terminology wins where aliases overlap.

      Example:

      "stainless steel 316"

      is preferred over:

      "stainless steel"
    */

    const sortedGroup =
      group
        .slice()
        .sort(
          function (a, b) {

            return b.length - a.length;

          }
        );


    /*
      Find which alias from this group appears
      as a complete search term.
    */

    const matchingAlias =
      sortedGroup.find(
        function (alias) {

          return containsSearchTerm(
            original,
            alias
          );

        }
      );


    if (!matchingAlias) {

      return;

    }


    /*
      Replace the detected alias with every
      equivalent form in its terminology group.
    */

    group.forEach(
      function (replacement) {

        const regex =
          new RegExp(
            `(^|[^a-z0-9])(${escapeRegExp(
              matchingAlias
            )})(?=$|[^a-z0-9])`,
            "gi"
          );


        const expandedVariant =
          original.replace(
            regex,
            function (
              match,
              prefix
            ) {

              return (
                prefix +
                replacement
              );

            }
          );


        variants.add(
          expandedVariant
        );

      }
    );

  }
);

  /* ========================================
     NUMERIC UNITS
  ======================================== */

  const unitRegex =
    /(\d+(?:\.\d+)?)\s*(a|amp|amps|ampere|amperes|v|volt|volts|hz|hertz|mm²|mm2|mmsq)\b/gi;


  const currentVariants =
    Array.from(variants);


  currentVariants.forEach(
    function (variant) {

      const unitMatches =
        Array.from(
          variant.matchAll(
            unitRegex
          )
        );


      unitMatches.forEach(
        function (unitMatch) {

          const matchedUnit =
            unitMatch[0];


          const canonical =
            getCanonicalNumericUnit(
              matchedUnit
            );


          if (!canonical) {
            return;
          }


          /*
            Search only:

            customer's existing form
            canonical spaced form
            canonical compact form

            We do NOT need separate API
            requests for:

            32 amp
            32 amps
            32 ampere
            32 amperes
          */

          variants.add(
            variant.replace(
              matchedUnit,
              canonical.spaced
            )
          );


          variants.add(
            variant.replace(
              matchedUnit,
              canonical.compact
            )
          );

        }
      );

    }
  );



  /* ========================================
     NORMALIZED FORMS
  ======================================== */

  Array.from(variants)
    .forEach(
      function (variant) {

        variants.add(
          normalizeSearchQuery(
            variant
          )
        );

      }
    );


  /* ========================================
     DEDUPLICATE EQUIVALENT RETRIEVAL QUERIES
  ======================================== */

  const uniqueVariants = [];
  const seenKeys =
    new Set();


  Array.from(variants)
    .forEach(
      function (variant) {

        const cleaned =
          String(variant || "")
            .trim()
            .replace(/\s+/g, " ");


        if (!cleaned) {
          return;
        }


        /*
          Use lowercase raw text as the
          deduplication key.

          We intentionally DON'T collapse
          hyphens here because:

          waterproof
          water-proof
          water proof

          may behave differently in Shopify's
          own search engine.
        */

        const key =
          cleaned.toLowerCase();


        if (
          seenKeys.has(key)
        ) {

          return;

        }


        seenKeys.add(key);

        uniqueVariants.push(
          cleaned
        );

      }
    );


  /*
    Full search retrieval budget.

    Matching/highlighting still retains the
    comprehensive 30-variant system.

    Only Shopify API retrieval is capped.
  */

  const MAX_RETRIEVAL_VARIANTS = 10;


  return uniqueVariants.slice(
    0,
    MAX_RETRIEVAL_VARIANTS
  );
}

/* ==========================================
   MULTI-CONCEPT API RETRIEVAL VARIANTS
========================================== */

function getMultiConceptRetrievalVariants(
  query
) {

  const variants =
    new Set();


  /*
    First keep the optimized variants for the
    complete query.

    This preserves strong Shopify relevance
    when the complete phrase does happen to
    exist.
  */

getRetrievalQueryVariants(
  meaningfulSearchQuery || query
).forEach(
  function (variant) {

    variants.add(
      variant
    );

  }
);


  /*
    Then retrieve candidates for each
    individual search concept.

    Final local AND filtering prevents these
    broader retrievals from polluting the
    displayed results.
  */

searchConceptDefinitions.forEach(
  function (conceptDefinition) {

    /*
      Existing deterministic retrieval:
      aliases, units, grammatical forms, etc.
    */

    getRetrievalQueryVariants(
      conceptDefinition.original
    ).forEach(
      function (variant) {

        variants.add(
          variant
        );

      }
    );


    /*
      Fuzzy retrieval.

      Example:

      conector
        ->
      connector
    */

    getFuzzyRetrievalVariants(
      conceptDefinition.original
    ).forEach(
      function (fuzzyVariant) {

        /*
          Run the corrected word through our
          normal retrieval engine as well.

          This lets all existing grammatical
          handling participate.
        */

        getRetrievalQueryVariants(
          fuzzyVariant
        ).forEach(
          function (variant) {

            variants.add(
              variant
            );

          }
        );

      }
    );

  }
);


  /*
    Full-search safety budget.

    Combined searches naturally require more
    retrieval coverage than single concepts,
    but we still keep an upper limit.
  */

  const MAX_MULTI_CONCEPT_RETRIEVAL_VARIANTS =
    16;


  return Array.from(variants)
    .filter(Boolean)
    .slice(
      0,
      MAX_MULTI_CONCEPT_RETRIEVAL_VARIANTS
    );
}




console.log(
  "Matching variants:",
  matchingVariants
);

/* ==========================================
   BUILD SEARCH CONCEPTS
========================================== */

/*
  Converts a customer query into independent
  concepts that must ALL exist in a result.

  Examples:

  32a panel
  ->
  [32a] AND [panel]


  shore power connector
  ->
  [shore power] AND [connector]


  single pole 500a
  ->
  [single pole] AND [500a]


  Multi-word terminology aliases remain one
  concept rather than being split apart.
*/

function buildSearchConcepts(query) {

  const original =
    String(query || "")
      .trim()
      .replace(/\s+/g, " ");


  if (!original) {
    return [];
  }


  /*
    Work on a temporary copy of the query.

    Recognised multi-word aliases are replaced
    with placeholders before ordinary
    whitespace splitting.
  */

  let workingQuery =
    original;


  const protectedConcepts = [];


  /* ========================================
     PROTECT MULTI-WORD ALIASES
  ======================================== */

  SEARCH_TERM_GROUPS.forEach(
    function (group) {

      /*
        Longer aliases first.

        Example:

        hazardous location
        before
        hazardous
      */

      const sortedGroup =
        group
          .slice()
          .sort(function (a, b) {

            return b.length - a.length;

          });


      sortedGroup.forEach(
        function (alias) {

          /*
            Only aliases containing spaces need
            protection from word splitting.
          */

          if (
            !alias.includes(" ")
          ) {

            return;

          }


          const regex =
            new RegExp(
              escapeRegExp(alias),
              "i"
            );


          const match =
            workingQuery.match(
              regex
            );


          if (!match) {
            return;
          }


          const placeholder =
            `__SEARCH_CONCEPT_${protectedConcepts.length}__`;


          protectedConcepts.push(
            match[0]
          );


          workingQuery =
            workingQuery.replace(
              regex,
              placeholder
            );

        }
      );

    }
  );


  /* ========================================
     PROTECT NUMBER + WORD UNIT PHRASES
  ======================================== */

  /*
    Examples:

    32 amps
    415 volts
    400 hertz
    70 mm2

    should each remain one concept.
  */

  const numericUnitRegex =
    /\d+(?:\.\d+)?\s+(?:amp|amps|ampere|amperes|volt|volts|hz|hertz|mm²|mm2|mmsq)\b/gi;


  workingQuery =
    workingQuery.replace(
      numericUnitRegex,
      function (match) {

        const placeholder =
          `__SEARCH_CONCEPT_${protectedConcepts.length}__`;


        protectedConcepts.push(
          match
        );


        return placeholder;
      }
    );


  /* ========================================
     SPLIT REMAINING QUERY
  ======================================== */

  const rawConcepts =
    workingQuery
      .split(/\s+/)
      .filter(Boolean);


  const concepts =
    rawConcepts.map(
      function (concept) {

        const placeholderMatch =
          concept.match(
            /^__SEARCH_CONCEPT_(\d+)__$/
          );


        if (placeholderMatch) {

          const index =
            Number(
              placeholderMatch[1]
            );


          return protectedConcepts[index];

        }


        return concept;

      }
    );


  /*
    Remove duplicates while preserving order.
  */

/* ========================================
   DEDUPLICATE PARSED CONCEPTS
======================================== */

const uniqueConcepts = [];
const seenConcepts =
  new Set();


concepts.forEach(
  function (concept) {

    const cleaned =
      String(concept || "")
        .trim();


    if (!cleaned) {
      return;
    }


    const key =
      normalizeForMatching(
        cleaned
      );


    if (
      seenConcepts.has(key)
    ) {

      return;

    }


    seenConcepts.add(key);

    uniqueConcepts.push(
      cleaned
    );

  }
);


/* ========================================
   REMOVE STANDALONE STOP WORDS
======================================== */

/*
  IMPORTANT:

  Stop words are checked against COMPLETE
  concepts only.

  Therefore:

  "for"       -> removed
  "form"      -> retained
  "transformer" -> retained
  "cee form"  -> retained
  "32A"       -> retained

  We are NOT deleting substrings from words.
*/

const meaningfulConcepts =
  uniqueConcepts.filter(
    function (concept) {

      const key =
        normalizeForMatching(
          concept
        );


      return !SEARCH_STOP_WORD_SET.has(
        key
      );

    }
  );


/* ========================================
   ALL-STOP-WORD SAFETY FALLBACK
======================================== */

/*
  Normally we use the filtered concepts.

  Example:

  "32a socket for panel"

  becomes:

  [32a, socket, panel]


  But if the visitor searches ONLY stop words:

  "for the"

  filtering would otherwise produce:

  []

  In that unusual case, preserve the original
  parsed concepts rather than creating an
  empty search.
*/

if (
  meaningfulConcepts.length > 0
) {

  return meaningfulConcepts;

}


return uniqueConcepts;
}


/* ==========================================
   GET MATCH VARIANTS FOR ONE CONCEPT
========================================== */

function getConceptMatchVariants(concept) {

  const variants =
    new Set();


  /*
    First use all existing deterministic
    search intelligence:

    - terminology aliases
    - technical units
    - normalization
  */

  expandSearchQueryVariants(
    concept
  ).forEach(
    function (variant) {

      variants.add(
        variant
      );

    }
  );


  /*
    Add singular/plural forms.

    Example:

    panels
      ->
    panels
    panel
  */

  Array.from(variants)
    .forEach(
      function (variant) {

        getWordFormVariants(
          variant
        ).forEach(
          function (wordForm) {

            variants.add(
              wordForm
            );

          }
        );

      }
    );


  /* ========================================
     FUZZY TYPO VARIANTS
  ======================================== */

  /*
    Unknown ordinary alphabetic terms may gain
    a high-confidence fuzzy vocabulary variant.

    Examples:

    conector
      ->
    connector

    panle
      ->
    panel

    Technical terms such as 32A, IP67, IK10
    and product codes are rejected by
    findFuzzyVocabularyMatch().
  */

  Array.from(variants)
    .forEach(
      function (variant) {

        const fuzzyMatch =
          findFuzzyVocabularyMatch(
            variant
          );


        if (
          !fuzzyMatch ||
          !fuzzyMatch.term
        ) {

          return;

        }




        variants.add(
          fuzzyMatch.term
        );


        /*
          Also let the corrected term participate
          in singular/plural handling.

          Example:

          conector
            ->
          connector
            ->
          connector / connectors
        */

        getWordFormVariants(
          fuzzyMatch.term
        ).forEach(
          function (wordForm) {

            variants.add(
              wordForm
            );

          }
        );

      }
    );


  /*
    Normalize and deduplicate everything for
    local title/body matching.
  */

  return Array.from(
    new Set(
      Array.from(variants).map(
        function (variant) {

          return normalizeForMatching(
            variant
          );

        }
      )
    )
  )
    .filter(Boolean)
    .sort(
      function (a, b) {

        return b.length - a.length;

      }
    );
}


/* ==========================================
   SEARCH CONCEPT STATE
========================================== */

const searchConcepts =
  buildSearchConcepts(
    originalQuery
  );


const searchConceptDefinitions =
  searchConcepts.map(
    function (concept) {

      return {

        original:
          concept,

        normalized:
          normalizeForMatching(
            concept
          ),

        variants:
          getConceptMatchVariants(
            concept
          )

      };

    }
  );

  /* ==========================================
   MEANINGFUL SEARCH QUERY
========================================== */

/*
  Used for Shopify retrieval.

  The customer's ORIGINAL query remains
  unchanged everywhere visible to them.

  Example:

  Original:
  32a socket for panel

  Retrieval:
  32a socket panel
*/

const meaningfulSearchQuery =
  searchConcepts.join(" ");


console.log(
  "Search concepts:",
  searchConceptDefinitions
);


/* ==========================================
   MATCH ONE CONCEPT AGAINST TEXT
========================================== */

function matchConceptInText(
  normalizedText,
  conceptDefinition
) {

  if (
    !normalizedText ||
    !conceptDefinition
  ) {

    return null;
  }


  /*
    Prefer the customer's exact concept.
  */

  if (
    conceptDefinition.normalized &&
    normalizedText.includes(
      conceptDefinition.normalized
    )
  ) {

    return {
      matched: true,
      exact: true,
      variant:
        conceptDefinition.normalized
    };

  }


  /*
    Otherwise accept any equivalent alias /
    technical-unit form.
  */

  const matchedVariant =
    conceptDefinition.variants.find(
      function (variant) {

        return normalizedText.includes(
          variant
        );

      }
    );


  if (matchedVariant) {

    return {
      matched: true,
      exact: false,
      variant:
        matchedVariant
    };

  }


  return {
    matched: false,
    exact: false,
    variant: null
  };
}




  /* ==========================================
     GRAPHQL SEARCH QUERY
  ========================================== */

  const SEARCH_QUERY = `
    query CustomSearch(
      $query: String!,
      $first: Int!,
      $after: String
    ) {

      search(
        query: $query,
        first: $first,
        after: $after,
        types: [ARTICLE, PAGE, PRODUCT],
        sortKey: RELEVANCE,
        prefix: LAST
      ) {

        totalCount

        edges {

          cursor

          node {

            __typename

            ... on Article {
              id
              title
              handle
              content
              excerpt
              onlineStoreUrl

              seo {
  title
  description
}

              image {
                url
                altText
              }
            }

            ... on Page {
              id
              title
              handle
              body
              onlineStoreUrl
            }

            ... on Product {
              id
              title
              handle
              description
              onlineStoreUrl

              featuredImage {
                url
                altText
              }
            }

          }

        }

        pageInfo {
          hasNextPage
          endCursor
        }

      }

    }
  `;


/* ==========================================
   FETCH ONE API BATCH
========================================== */

async function fetchSearchBatch(
  searchQuery,
  afterCursor = null
) {

  const response =
    await fetch(endpoint, {

      method: "POST",

      headers: {
        "Content-Type": "application/json",

        "X-Shopify-Storefront-Access-Token":
          STOREFRONT_TOKEN
      },

      body: JSON.stringify({

        query:
          SEARCH_QUERY,

        variables: {

          /*
            IMPORTANT:

            The query is now supplied to this
            function rather than always using
            normalizedQuery.

            This allows alias variants to be
            searched independently.
          */

          query:
            searchQuery,

          first:
            API_BATCH_SIZE,

          after:
            afterCursor
        }

      })

    });


  if (!response.ok) {

    throw new Error(
      `Storefront API request failed with status ${response.status}`
    );

  }


  const result =
    await response.json();


  if (result.errors) {

    console.error(
      "Shopify GraphQL errors:",
      result.errors
    );


    throw new Error(
      "Shopify returned a GraphQL error."
    );

  }


  return result.data.search;
}


/* ==========================================
   FETCH ALL RESULTS FOR ONE QUERY VARIANT
========================================== */

async function fetchAllResultsForVariant(
  searchQuery
) {

  let allEdges = [];
  let afterCursor = null;
  let batchNumber = 0;
  let continueFetching = true;


  while (
    continueFetching &&
    batchNumber < MAX_API_BATCHES
  ) {

    batchNumber += 1;


    const search =
      await fetchSearchBatch(
        searchQuery,
        afterCursor
      );


    if (
      !search ||
      !search.edges ||
      search.edges.length === 0
    ) {

      break;

    }


    allEdges =
      allEdges.concat(
        search.edges
      );


    console.log(
      `Search variant "${searchQuery}" batch ${batchNumber}:`,
      search.edges.length,
      "results"
    );


    if (
      search.pageInfo &&
      search.pageInfo.hasNextPage &&
      search.pageInfo.endCursor
    ) {

      afterCursor =
        search.pageInfo.endCursor;

    } else {

      continueFetching = false;

    }

  }


  if (
    batchNumber >=
    MAX_API_BATCHES
  ) {

    console.warn(
      `Search variant "${searchQuery}" reached the API batch safety limit.`
    );

  }


  return allEdges;
}


/* ==========================================
   FETCH ALL ALIAS CANDIDATE RESULTS
========================================== */

async function fetchAllCandidateResults() {

  /*
    Generate every useful spelling /
    terminology / unit version of the
    customer's query.
  */

const searchVariants =
  getMultiConceptRetrievalVariants(
    originalQuery
  );


console.log(
  "Multi-concept API retrieval variants:",
  searchVariants
);


  /*
    Search all variants concurrently.

    This is substantially faster than waiting
    for one complete variant before starting
    the next.
  */

  const variantEdgeGroups =
    await Promise.all(

      searchVariants.map(
        function (variant) {

          return fetchAllResultsForVariant(
            variant
          );

        }
      )

    );


  /*
    Flatten all Shopify results into one
    candidate collection.
  */

  const allEdges =
    variantEdgeGroups.flat();


  /*
    Deduplicate by Shopify ID.

    The same article will frequently be
    returned by several alias searches.

    Example:

    "waterproof"
    "water proof"
    "water-proof"

    may all return the same page.
  */

  const uniqueResults = [];
  const seenIds = new Set();


  allEdges.forEach(
    function (edge) {

      const item =
        edge.node;


      if (
        !item ||
        !item.id
      ) {

        return;

      }


      if (
        seenIds.has(
          item.id
        )
      ) {

        return;

      }


      seenIds.add(
        item.id
      );


      uniqueResults.push(
        item
      );

    }
  );


  console.log(
    "Unique candidates after alias merging:",
    uniqueResults.length
  );


  return uniqueResults;
}


  /* ==========================================
     GET SEARCHABLE CONTENT FROM RESULT
  ========================================== */

  function getItemBody(item) {

    if (!item) {
      return "";
    }


    if (item.__typename === "Article") {

      return item.content || "";

    }


    if (item.__typename === "Page") {

      return item.body || "";

    }


    if (item.__typename === "Product") {

      return item.description || "";

    }


    return "";
  }


/* ==========================================
   DETERMINE MULTI-CONCEPT MATCH TYPE
========================================== */

function classifyResult(item) {

  const title =
    item.title || "";


  const body =
    getItemBody(item);


  const normalizedTitle =
    normalizeForMatching(
      title
    );


  const normalizedBody =
    normalizeForMatching(
      body
    );


  /*
    Test EVERY search concept independently.
  */

  const conceptMatches =
    searchConceptDefinitions.map(
      function (conceptDefinition) {

        const titleResult =
          matchConceptInText(
            normalizedTitle,
            conceptDefinition
          );


        const bodyResult =
          matchConceptInText(
            normalizedBody,
            conceptDefinition
          );


        const matched =
          titleResult.matched ||
          bodyResult.matched;


        return {

          concept:
            conceptDefinition.original,

          matched:
            matched,

          titleMatch:
            titleResult.matched,

          bodyMatch:
            bodyResult.matched,

          exactTitleMatch:
            titleResult.matched &&
            titleResult.exact,

          exactBodyMatch:
            bodyResult.matched &&
            bodyResult.exact,

          matchedTitleVariant:
            titleResult.variant,

          matchedBodyVariant:
            bodyResult.variant

        };

      }
    );


  /*
    UNIVERSAL AND RULE

    Every concept must exist somewhere in the
    same result.

    Example:

    32a panel

    32A in title + panel in body = PASS
    32A in title only           = FAIL
    panel in body only          = FAIL
  */

  const allConceptsMatch =
    conceptMatches.length > 0 &&
    conceptMatches.every(
      function (match) {

        return match.matched;

      }
    );


  /*
    Useful aggregate information for rendering
    and ranking.
  */

  const titleMatch =
    allConceptsMatch &&
    conceptMatches.some(
      function (match) {

        return match.titleMatch;

      }
    );


  const bodyMatch =
    allConceptsMatch &&
    conceptMatches.some(
      function (match) {

        return match.bodyMatch;

      }
    );


  const allConceptsInTitle =
    allConceptsMatch &&
    conceptMatches.every(
      function (match) {

        return match.titleMatch;

      }
    );


  const allConceptsExactInTitle =
    allConceptsMatch &&
    conceptMatches.every(
      function (match) {

        return match.exactTitleMatch;

      }
    );


  const exactTitleCount =
    conceptMatches.filter(
      function (match) {

        return match.exactTitleMatch;

      }
    ).length;


  const titleConceptCount =
    conceptMatches.filter(
      function (match) {

        return match.titleMatch;

      }
    ).length;

    /*
  Determine whether at least one search
  concept is missing from the title but is
  successfully matched in the body.

  This tells the renderer whether the
  description needs to explain an otherwise
  invisible search match.
*/

const hasBodyOnlyConcept =
  conceptMatches.some(
    function (match) {

      return (
        !match.titleMatch &&
        match.bodyMatch
      );

    }
  );




  /*
    RANKING

    1 = every concept appears exactly in title

    2 = every concept appears in title, but one
        or more uses an alias

    3 = some concepts in title and remaining
        concepts in body

    4 = all concepts matched, but only in body

    5 = not a valid AND result
  */

  let priority = 5;


  if (
    allConceptsExactInTitle
  ) {

    priority = 1;

  } else if (
    allConceptsInTitle
  ) {

    priority = 2;

  } else if (
    allConceptsMatch &&
    titleConceptCount > 0
  ) {

    priority = 3;

  } else if (
    allConceptsMatch
  ) {

    priority = 4;

  }


  return {

    item:
      item,

    conceptMatches:
      conceptMatches,

    allConceptsMatch:
      allConceptsMatch,

    titleMatch:
      titleMatch,

    bodyMatch:
      bodyMatch,

    allConceptsInTitle:
      allConceptsInTitle,

      hasBodyOnlyConcept:
  hasBodyOnlyConcept,

    exactTitleCount:
      exactTitleCount,

    titleConceptCount:
      titleConceptCount,

    priority:
      priority

  };
}


  /* ==========================================
     FILTER + RANK RESULTS
  ========================================== */

  function prepareResults(items) {

    const classified =
      items.map(classifyResult);


    /*
      Your original requirement was to search
      titles and contents rather than tags.

      Therefore results returned only because
      of tags / other indexed fields are removed.
    */

const relevant =
  classified.filter(
    function (result) {

      return (
        result.allConceptsMatch
      );

    }
  );


    /*
      JavaScript Array.sort is stable in modern
      browsers.

      Results with the same priority therefore
      retain Shopify's original relevance order.
    */

    relevant.sort(function (a, b) {

      return a.priority - b.priority;

    });


    return relevant;
  }


  /* ==========================================
     SEARCH STATE
  ========================================== */

  let preparedResults = [];
  let currentPage = 1;


  /* ==========================================
     END OF PART 1
     PART 2 MUST BE PASTED DIRECTLY BELOW
  ========================================== */

    /* ==========================================
     HTML ESCAPING
  ========================================== */

  function escapeHtml(value) {

    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }


  /* ==========================================
     REGEX ESCAPING
  ========================================== */

  function escapeRegExp(value) {

    

    return String(value)
      .replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  /* ==========================================
   SAFE SEARCH TERM MATCHING
========================================== */

/*
  Checks whether a search term occurs as a
  meaningful standalone term rather than as
  an arbitrary substring inside another word.

  Examples:

  "ss junction box" + "ss"
  -> true

  "stainless steel" + "ss"
  -> false

  "class" + "ss"
  -> false

  "assembly" + "ss"
  -> false


  Longer technical forms can still sit beside
  numbers:

  "ss316" is NOT treated as standalone "ss".
*/

function containsSearchTerm(
  text,
  term
) {

  const source =
    String(text || "")
      .toLowerCase();


  const target =
    String(term || "")
      .trim()
      .toLowerCase();


  if (!target) {

    return false;

  }


  const escaped =
    escapeRegExp(
      target
    );


  /*
    (^|[^a-z0-9]) ensures that the term does
    not begin inside another alphanumeric word.

    ($|[^a-z0-9]) does the same at the end.
  */

  const regex =
    new RegExp(
      `(^|[^a-z0-9])${escaped}(?=$|[^a-z0-9])`,
      "i"
    );


  return regex.test(
    source
  );
}


/* ==========================================
   BUILD SEARCH VARIANTS FOR HIGHLIGHTING
========================================== */

function getHighlightVariants(query) {

  const variants =
    new Set();


  /*
    Include all terminology and numeric-unit
    variants generated by our alias engine.
  */

  expandSearchQueryVariants(
    query
  ).forEach(
    function (variant) {

      variants.add(
        variant
      );


      variants.add(
        normalizeSearchQuery(
          variant
        )
      );

    }
  );

  /*
  Add singular/plural word forms.

  Example:

  Search:
  panels

  Page:
  Panel Mounted Socket

  "Panel" can still be highlighted.
*/

Array.from(variants)
  .forEach(
    function (variant) {

      getWordFormVariants(
        variant
      ).forEach(
        function (wordForm) {

          variants.add(
            wordForm
          );

        }
      );

    }
  );


  /* ========================================
   FUZZY HIGHLIGHT VARIANTS
======================================== */

/*
  Highlight the correctly spelled vocabulary
  form when the customer entered a typo.

  Example:

  Search:
  conector

  Result:
  Connector

  -> "Connector" is highlighted.
*/

Array.from(variants)
  .forEach(
    function (variant) {

      const fuzzyMatch =
        findFuzzyVocabularyMatch(
          variant
        );


      if (
        !fuzzyMatch ||
        !fuzzyMatch.term
      ) {

        return;

      }


      variants.add(
        fuzzyMatch.term
      );


      getWordFormVariants(
        fuzzyMatch.term
      ).forEach(
        function (wordForm) {

          variants.add(
            wordForm
          );

        }
      );

    }
  );


  /*
    Add compact technical forms as well.

    Example:

    400 Hz -> 400Hz
    32 A   -> 32A
    70 mm² -> 70mm²
  */

  Array.from(variants)
    .forEach(
      function (variant) {

        const compact =
          normalizeSearchQuery(
            variant
          )
            .replace(
              /(\d+)\s+(hz)\b/gi,
              "$1$2"
            )
            .replace(
              /(\d+)\s+(kv)\b/gi,
              "$1$2"
            )
            .replace(
              /(\d+)\s+(v)\b/gi,
              "$1$2"
            )
            .replace(
              /(\d+)\s+(ka)\b/gi,
              "$1$2"
            )
            .replace(
              /(\d+)\s+(a)\b/gi,
              "$1$2"
            )
            .replace(
              /(\d+)\s+(kva)\b/gi,
              "$1$2"
            )
            .replace(
              /(\d+)\s+(kw)\b/gi,
              "$1$2"
            )
            .replace(
              /(\d+)\s+(mm2)\b/gi,
              "$1$2"
            )
            .replace(
              /(\d+)\s+(mm²)/gi,
              "$1$2"
            );


        variants.add(
          compact
        );

      }
    );


  return Array.from(
    variants
  )
    .filter(Boolean)
    .sort(function (a, b) {

      /*
        Longer aliases first prevents:

        "hazardous"

        from being highlighted before:

        "hazardous area"
      */

      return b.length - a.length;

    });
}


/* ==========================================
   BUILD FINAL HIGHLIGHT VARIANTS
========================================== */

const highlightVariantSet =
  new Set();


/*
  First process the complete customer query.

  This is important for terminology aliases
  that span multiple parsed concepts.

  Example:

  stainless steel 316
        ->
  SS316
  SS 316
  316 stainless steel
*/

getHighlightVariants(
  meaningfulSearchQuery ||
  originalQuery
).forEach(
  function (variant) {

    highlightVariantSet.add(
      variant
    );

  }
);


/*
  Then process each individual concept.

  This preserves our existing multi-concept
  highlighting behaviour.

  Example:

  32A panel socket
    ->
  32A
  panel
  socket
*/

searchConceptDefinitions.forEach(
  function (conceptDefinition) {

    getHighlightVariants(
      conceptDefinition.original
    ).forEach(
      function (variant) {

        highlightVariantSet.add(
          variant
        );

      }
    );

  }
);


const highlightVariants =
  Array.from(
    highlightVariantSet
  )
    .filter(Boolean)
    .sort(
      function (a, b) {

        return b.length - a.length;

      }
    );




/* ==========================================
   HIGHLIGHT MATCHING TEXT
========================================== */

function highlightText(text) {

  const safeText =
    escapeHtml(text);


  /*
    Prepare all usable highlight variants.

    Longer variants are placed first so that:

    "stainless steel"

    is preferred over shorter overlapping
    variants.
  */

  const usableVariants =
    Array.from(
      new Set(
        highlightVariants
          .map(function (variant) {

            return String(
              variant || ""
            ).trim();

          })
          .filter(Boolean)
      )
    )
      .sort(function (a, b) {

        return b.length - a.length;

      });


  if (
    usableVariants.length === 0
  ) {

    return safeText;

  }


  /*
    Build ONE regex containing every highlight
    variant.

    This is important because the original text
    is processed only once. Generated <strong>
    markup can therefore never be searched or
    highlighted by a later pass.
  */

  const variantPattern =
    usableVariants
      .map(function (variant) {

        return escapeRegExp(
          escapeHtml(variant)
        );

      })
      .join("|");


  /*
    Require alphanumeric boundaries around the
    complete match.

    This prevents short terms such as "ss"
    matching inside:

    stainless
    class
    assembly

    but still allows:

    SS
    (SS)
    SS-junction-box

    SS316 deliberately does NOT count as a
    standalone "SS" match.
  */

  const regex =
    new RegExp(
      `(^|[^a-z0-9])(${variantPattern})(?=$|[^a-z0-9])`,
      "gi"
    );


  return safeText.replace(
    regex,
    function (
      match,
      prefix,
      matchedText
    ) {

      return (
        prefix +
        '<strong class="highlight">' +
        matchedText +
        '</strong>'
      );

    }
  );
}


  /* ==========================================
     CLEAN TEXT
  ========================================== */

/* ==========================================
   CLEAN ARTICLE CONTENT FOR SEARCH EXCERPTS
========================================== */

function cleanText(content) {

  if (!content) {
    return "";
  }


  /*
    Parse the article HTML in memory.

    This does NOT modify the actual blog post.
  */

  const parser =
    new DOMParser();


  const documentCopy =
    parser.parseFromString(
      String(content),
      "text/html"
    );


  /*
    Remove elements that should never appear
    in search-result excerpts.
  */

const unwantedSelectors = [
  "style",
  "script",
  "noscript",
  "svg",
  "template",

  /* Navigation / breadcrumbs */
  "nav",
  ".breadcrumb-nav",
  ".anchor-links",

  /* Back-navigation elements */
  ".back-link",

  /* Contact / CTA sections */
  ".contact-cta"
];


  documentCopy
    .querySelectorAll(
      unwantedSelectors.join(",")
    )
    .forEach(function (element) {

      element.remove();

    });


  /*
    Extract the remaining text.
  */

  let text =
    documentCopy.body
      ? documentCopy.body.textContent
      : documentCopy.textContent;


  text =
    String(text || "");

    /*
  Remove CSS / JavaScript block comments.

  Examples:

  /* ===== POWERLOCK ===== *\/
  /* Header styling *\/
  /* Product table *\/
*/

text =
  text.replace(
    /\/\*[\s\S]*?\*\//g,
    " "
  );


/*
  Remove HTML comments that may survive
  Shopify's content representation.

  Example:

  <!-- Quick Navigation -->
*/

text =
  text.replace(
    /<!--[\s\S]*?-->/g,
    " "
  );


  /*
    Remove CSS declarations that survive
    Shopify's article-content representation.

    Example:

    td{
      border:none;
      position:relative;
      height:300px;
    }

    This catches selector + declaration blocks
    without requiring individual blog posts
    to be edited.
  */

  text =
    text.replace(
      /(?:^|\s)[.#]?[a-zA-Z][a-zA-Z0-9_\-]*(?:\s+[.#]?[a-zA-Z][a-zA-Z0-9_\-]*)?\s*\{[^{}]*\}/g,
      " "
    );


  /*
    Catch simple CSS selector blocks involving
    pseudo-classes, attributes, commas, etc.

    Examples:

    td, th { ... }
    tr:hover { ... }
    .class-name { ... }
    #element { ... }
  */

  text =
    text.replace(
      /(?:^|\s)[^{}]{1,120}\{[^{}]*:[^{}]*\}/g,
      " "
    );


  /*
    Remove common visible UI/helper text that
    isn't useful as product-description content.
  */

  text =
    text.replace(
      /\bHover to zoom\b/gi,
      " "
    );


    /* ==========================================
   REMOVE FLATTENED STRUCTURED DATA
========================================== */

/*
  Shopify may return article.content as
  flattened text.

  This means JSON-LD that originally lived
  inside:

  <script type="application/ld+json">

  can survive as visible text such as:

  {
    "@context": "https://schema.org",
    "@type": "Product",
    ...
  }

  Search excerpts should never display this.
*/

const structuredDataStartPatterns = [
  /\{\s*"@context"\s*:\s*"https?:\/\/schema\.org"/i,
  /\{\s*"@context"\s*:\s*"https?:\\\/\\\/schema\.org"/i
];


let structuredDataPosition = -1;


structuredDataStartPatterns.forEach(
  function (pattern) {

    const match =
      text.match(pattern);


    if (
      match &&
      (
        structuredDataPosition === -1 ||
        match.index < structuredDataPosition
      )
    ) {

      structuredDataPosition =
        match.index;

    }

  }
);


/*
  Structured data normally appears near the
  end of these product/blog pages.

  Once it begins, everything after it is not
  useful customer-facing excerpt content.
*/

if (
  structuredDataPosition !== -1
) {

  text =
    text.slice(
      0,
      structuredDataPosition
    );

}


  /*
    Normalise HTML entities / spaces and
    collapse excessive whitespace.
  */

  text =
    text
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim();


  return text;
}


  /* ==========================================
     FIND MATCH POSITION IN BODY
  ========================================== */

  function findBodyMatchPosition(body) {

    const cleanBody =
      cleanText(body);

    const normalizedBody =
      normalizeForMatching(cleanBody);


    const position =
      normalizedBody.indexOf(matchingQuery);


    return {
      cleanBody: cleanBody,
      position: position
    };
  }

  /* ==========================================
   FIND BEST MATCHING VARIANT IN TEXT
========================================== */

function findBestMatchingVariant(text) {

  if (!text) {
    return null;
  }


  const normalizedText =
    normalizeForMatching(text);


  /*
    Prefer the customer's exact wording
    whenever it actually occurs.
  */

  if (
    matchingQuery &&
    normalizedText.includes(
      matchingQuery
    )
  ) {

    return matchingQuery;

  }


  /*
    Otherwise find the longest equivalent
    alias that actually occurs.

    matchingVariants is already sorted
    longest-first.
  */

  const aliasMatch =
    matchingVariants.find(
      function (variant) {

        return normalizedText.includes(
          variant
        );

      }
    );


  return aliasMatch || null;
}


/* ==========================================
   FIND ALL QUERY OCCURRENCES
========================================== */

function findAllMatchPositions(text, query) {

  const positions = [];

  if (!text || !query) {
    return positions;
  }

  let startPosition = 0;

  while (startPosition < text.length) {

    const position =
      text.indexOf(
        query,
        startPosition
      );

    if (position === -1) {
      break;
    }

    positions.push(position);

    startPosition =
      position + query.length;
  }

  return positions;
}


/* ==========================================
   BUILD CONTEXT CANDIDATE
========================================== */

function buildContextCandidate(
  cleanBody,
  matchPosition
) {

  /*
    We inspect a larger region first.

    The final displayed excerpt will be
    shortened later.
  */

  const CONTEXT_CHARACTERS = 350;

  const start =
    Math.max(
      0,
      matchPosition -
      CONTEXT_CHARACTERS
    );

  const end =
    Math.min(
      cleanBody.length,
      matchPosition +
      matchingQuery.length +
      CONTEXT_CHARACTERS
    );

  return {
    text:
      cleanBody.slice(
        start,
        end
      ),

    start:
      start,

    end:
      end,

    matchOffset:
      matchPosition - start
  };
}


/* ==========================================
   MEASURE CONCEPT COVERAGE IN TEXT
========================================== */

function getConceptCoverage(text) {

  const normalizedText =
    normalizeForMatching(text);


  const matchedConcepts = [];


  searchConceptDefinitions.forEach(
    function (definition) {

      const match =
        matchConceptInText(
          normalizedText,
          definition
        );


      if (
        match &&
        match.matched
      ) {

        matchedConcepts.push({
          concept:
            definition.original,

          variant:
            match.variant,

          exact:
            match.exact
        });

      }

    }
  );


  return {

    count:
      matchedConcepts.length,

    total:
      searchConceptDefinitions.length,

    allMatched:
      (
        searchConceptDefinitions.length > 0 &&
        matchedConcepts.length ===
          searchConceptDefinitions.length
      ),

    matches:
      matchedConcepts

  };
}

/* ==========================================
   GET CONCEPTS ALREADY VISIBLE IN TITLE
========================================== */

function getTitleConceptCoverage(title) {

  const normalizedTitle =
    normalizeForMatching(
      title || ""
    );


  const matchedConcepts =
    new Set();


  searchConceptDefinitions.forEach(
    function (definition) {

      const match =
        matchConceptInText(
          normalizedTitle,
          definition
        );


      if (
        match &&
        match.matched
      ) {

        matchedConcepts.add(
          definition.original
        );

      }

    }
  );


  return matchedConcepts;
}

/* ==========================================
   CONCEPT SPECIFICITY SCORE
========================================== */

/*
  Used only as a tie-breaker when two final
  excerpts cover the same number of otherwise
  unexplained search concepts.

  More technical / distinctive concepts are
  preferred over broad ordinary words.

  Examples:

  IK10        > localized
  32A         > connector
  415V        > socket

  This is universal and does NOT hard-code
  particular words.
*/

function getConceptSpecificity(
  definition
) {

  const concept =
    String(
      definition.original || ""
    ).trim();


  if (!concept) {
    return 0;
  }


  let score = 0;


  /*
    Longer terms are generally more specific.
  */

  score +=
    Math.min(
      concept.length,
      20
    );


  /*
    Numbers are a strong technical signal.

    Examples:

    IK10
    32A
    415V
    400Hz
  */

  if (/\d/.test(concept)) {

    score += 20;

  }


  /*
    Mixed letters + numbers are especially
    distinctive in an industrial catalogue.
  */

  if (
    /[a-z]/i.test(concept) &&
    /\d/.test(concept)
  ) {

    score += 10;

  }


  /*
    Multi-word concepts are normally more
    specific than a single generic word.

    Example:

    shore power
    single pole
  */

  if (/\s/.test(concept)) {

    score += 8;

  }


  return score;
}



/* ==========================================
   SCORE CONTEXT CANDIDATE
========================================== */

function scoreContextCandidate(candidate) {

  const text =
    candidate.text;

  let score = 0;

  /*
  Multi-concept coverage is the strongest
  excerpt-selection signal.

  Example:

  Query:
  32a 415v panel

  Passage containing all 3 concepts should
  strongly outrank one containing only 1.
*/

const coverage =
  getConceptCoverage(
    candidate.text
  );


candidate.conceptCoverage =
  coverage;


score +=
  coverage.count * 25;


/*
  Give a substantial bonus when one natural
  passage contains EVERY search concept.
*/

if (
  coverage.allMatched
) {

  score += 40;

}


  /*
    Reward sentence-like prose.
  */

  const sentenceMarks =
    (
      text.match(/[.!?]/g) ||
      []
    ).length;

  score +=
    sentenceMarks * 3;


  /*
    Reward commas because they are another
    useful signal of natural prose.
  */

  const commas =
    (
      text.match(/,/g) ||
      []
    ).length;

  score += commas;


  /*
    Reward reasonable average word length.
  */

  const words =
    text
      .split(/\s+/)
      .filter(Boolean);

  if (words.length >= 12) {
    score += 4;
  }

  if (words.length >= 20) {
    score += 3;
  }


  /*
    Penalise common navigation / UI language.
  */

  const navigationTerms = [
    "home",
    "overview",
    "products",
    "resources",
    "faq",
    "back to",
    "contact our team",
    "technical resources",
    "related products",
    "why buy from us",
    "browse other connectors",
"related connectors",
"other connectors",
"back to bemis",
"back to proconect"
  ];


  navigationTerms.forEach(
    function (term) {

      if (
        text
          .toLowerCase()
          .includes(term)
      ) {

        score -= 8;

      }

    }
  );


  /*
    Penalise text that looks like residual
    CSS or code.
  */

  if (
    /[.#]?[a-z0-9_-]+\s*\{[^}]*\}/i.test(
      text
    )
  ) {

    score -= 15;

  }


  if (
    text.includes("/*") ||
    text.includes("*/")
  ) {

    score -= 15;

  }


  /*
    Slightly prefer matches that are not
    right at the beginning of a noisy page.
  */

  if (candidate.start > 100) {
    score += 2;
  }


  return score;
}


/* ==========================================
   BUILD FINAL 22-WORD EXCERPT CANDIDATE
========================================== */

/*
  Creates the actual text window that could
  be displayed to the customer.

  Unlike createFixedContextExcerpt(), this
  returns plain text and metadata rather than
  highlighted HTML.

  This allows us to score concept coverage
  AFTER the final 22-word trimming.
*/

function buildFinalExcerptCandidate(
  text,
  matchedVariant
) {

  const words =
    String(text || "")
      .split(/\s+/)
      .filter(Boolean);


  const MAX_WORDS = 22;
  const WORDS_BEFORE = 6;


  if (
    words.length === 0 ||
    !matchedVariant
  ) {

    return {
      text: "",
      startIndex: 0,
      endIndex: 0
    };

  }


  const normalizedText =
    normalizeForMatching(
      text
    );


  const matchPosition =
    normalizedText.indexOf(
      matchedVariant
    );


  if (matchPosition === -1) {

    return {
      text:
        words
          .slice(0, MAX_WORDS)
          .join(" "),

      startIndex: 0,

      endIndex:
        Math.min(
          words.length,
          MAX_WORDS
        )
    };

  }


  /*
    Determine which word contains the
    beginning of the matched concept.
  */

  let characterCount = 0;
  let matchWordIndex = 0;


  for (
    let i = 0;
    i < words.length;
    i += 1
  ) {

    const wordEnd =
      characterCount +
      words[i].length;


    if (
      matchPosition <=
      wordEnd
    ) {

      matchWordIndex = i;
      break;

    }


    characterCount =
      wordEnd + 1;

  }


  let startIndex =
    Math.max(
      0,
      matchWordIndex -
      WORDS_BEFORE
    );


  let endIndex =
    Math.min(
      words.length,
      startIndex +
      MAX_WORDS
    );


  /*
    If we reached the end, move backward so
    the excerpt still uses up to 22 words.
  */

  if (
    endIndex ===
    words.length
  ) {

    startIndex =
      Math.max(
        0,
        endIndex -
        MAX_WORDS
      );

  }


  return {

    text:
      words
        .slice(
          startIndex,
          endIndex
        )
        .join(" "),

    startIndex:
      startIndex,

    endIndex:
      endIndex

  };
}

/* ==========================================
   FIND BEST EXCERPT ANCHOR
========================================== */

function findBestExcerptAnchor(text) {

  const normalizedText =
    normalizeForMatching(
      text
    );


  let bestVariant = null;
  let earliestPosition = Infinity;


  searchConceptDefinitions.forEach(
    function (definition) {

      definition.variants.forEach(
        function (variant) {

          const position =
            normalizedText.indexOf(
              variant
            );


          if (
            position !== -1 &&
            position < earliestPosition
          ) {

            earliestPosition =
              position;

            bestVariant =
              variant;

          }

        }
      );

    }
  );


  return bestVariant;
}



/* ==========================================
   SCORE FINAL DISPLAY EXCERPT
========================================== */

function scoreFinalExcerptCandidate(
  candidate,
  title = ""
) {

  const anchorVariant =
    findBestExcerptAnchor(
      candidate.text
    );


  if (!anchorVariant) {

    return null;

  }


  const finalWindow =
    buildFinalExcerptCandidate(
      candidate.text,
      anchorVariant
    );


  if (!finalWindow.text) {

    return null;

  }


  /*
    Measure concept coverage against the
    ACTUAL final 22-word excerpt.
  */

  const finalCoverage =
    getConceptCoverage(
      finalWindow.text
    );


  /*
    Determine which concepts are already
    explained by the result title.
  */

  const titleConcepts =
    getTitleConceptCoverage(
      title
    );


  /*
    Concepts appearing in the excerpt but NOT
    already visible in the title are especially
    valuable.

    The excerpt's job is to explain why the
    remaining query concepts matched.
  */

  const unexplainedMatches =
    finalCoverage.matches.filter(
      function (match) {

        return !titleConcepts.has(
          match.concept
        );

      }
    );


  /*
    Calculate specificity only across those
    otherwise-unexplained concepts.
  */

  let specificityScore = 0;


  unexplainedMatches.forEach(
    function (match) {

      const definition =
        searchConceptDefinitions.find(
          function (candidateDefinition) {

            return (
              candidateDefinition.original ===
              match.concept
            );

          }
        );


      if (definition) {

        specificityScore +=
          getConceptSpecificity(
            definition
          );

      }

    }
  );


  return {

    candidate:
      candidate,

    anchorVariant:
      anchorVariant,

    finalText:
      finalWindow.text,

    finalCoverage:
      finalCoverage,

    /*
      Number of concepts this excerpt explains
      that the title does NOT already explain.
    */

    unexplainedConceptCount:
      unexplainedMatches.length,

    specificityScore:
      specificityScore,

    proseScore:
      scoreContextCandidate(
        candidate
      )

  };
}



/* ==========================================
   CREATE FIXED-LENGTH ALIAS-AWARE EXCERPT
========================================== */

function createFixedContextExcerpt(
  text,
  matchedVariant
) {

  const words =
    text
      .split(/\s+/)
      .filter(Boolean);


  const MAX_WORDS = 22;


  if (
    !text ||
    !matchedVariant
  ) {

    const fallback =
      words
        .slice(
          0,
          MAX_WORDS
        )
        .join(" ");


    return (
      escapeHtml(fallback) +
      (
        words.length >
        MAX_WORDS
          ? "..."
          : ""
      )
    );

  }


  const normalizedText =
    normalizeForMatching(
      text
    );


  const matchPosition =
    normalizedText.indexOf(
      matchedVariant
    );


  if (matchPosition === -1) {

    const fallback =
      words
        .slice(
          0,
          MAX_WORDS
        )
        .join(" ");


    return (
      highlightText(fallback) +
      (
        words.length >
        MAX_WORDS
          ? "..."
          : ""
      )
    );

  }


  /*
    Determine which word contains the
    beginning of the alias match.
  */

  let characterCount = 0;
  let matchWordIndex = 0;


  for (
    let i = 0;
    i < words.length;
    i += 1
  ) {

    const wordEnd =
      characterCount +
      words[i].length;


    if (
      matchPosition <=
      wordEnd
    ) {

      matchWordIndex = i;
      break;

    }


    characterCount =
      wordEnd + 1;
  }


  /*
    Keep the matching phrase around the
    middle of the ~30-word excerpt.
  */

  const WORDS_BEFORE = 6;


  let startIndex =
    Math.max(
      0,
      matchWordIndex -
      WORDS_BEFORE
    );


  let endIndex =
    Math.min(
      words.length,
      startIndex +
      MAX_WORDS
    );


  /*
    If we hit the end of the candidate,
    shift backward to make fuller use of
    the 30-word allowance.
  */

  if (
    endIndex ===
    words.length
  ) {

    startIndex =
      Math.max(
        0,
        endIndex -
        MAX_WORDS
      );

  }


  const excerpt =
    words
      .slice(
        startIndex,
        endIndex
      )
      .join(" ");


  const prefix =
    startIndex > 0
      ? "..."
      : "";


  const suffix =
    endIndex < words.length
      ? "..."
      : "";


  /*
    highlightText() is already alias-aware
    after our previous search upgrade.

    Therefore if the customer searched:

    loadbank

    and the excerpt contains:

    load bank

    the actual "load bank" text is
    highlighted.
  */

  return (
    prefix +
    highlightText(excerpt) +
    suffix
  );
}


/* ==========================================
   FIND ALL CONCEPT POSITIONS IN BODY
========================================== */

function findAllConceptPositions(
  normalizedBody
) {

  const positions =
    new Set();


  searchConceptDefinitions.forEach(
    function (definition) {

      /*
        Check every equivalent form belonging
        to this concept.
      */

      definition.variants.forEach(
        function (variant) {

          findAllMatchPositions(
            normalizedBody,
            variant
          ).forEach(
            function (position) {

              positions.add(
                position
              );

            }
          );

        }
      );

    }
  );


  return Array.from(positions)
    .sort(function (a, b) {

      return a - b;

    });
}


/* ==========================================
   SMART MULTI-CONCEPT CONTEXTUAL EXCERPT
========================================== */

function createContextualExcerpt(
  body,
  seoDescription = ""
) {

  /* ========================================
     FIRST CHOICE:
     SEO DESCRIPTION CONTAINING ALL CONCEPTS
  ======================================== */

  if (seoDescription) {

    const seoCoverage =
      getConceptCoverage(
        seoDescription
      );


    /*
      If the human-written SEO description
      contains EVERY concept, it is normally
      the cleanest possible excerpt.
    */

    if (
      seoCoverage.allMatched
    ) {

      return highlightText(
        seoDescription.trim()
      );

    }

  }

  


  /* ========================================
     ARTICLE BODY
  ======================================== */

  const cleanBody =
    cleanText(body);


  if (!cleanBody) {

    if (seoDescription) {

      return escapeHtml(
        seoDescription.trim()
      );

    }


    return "";

  }


  const normalizedBody =
    normalizeForMatching(
      cleanBody
    );


  /*
    Find occurrences belonging to EVERY
    search concept rather than choosing one
    alias up front.
  */

  const positions =
    findAllConceptPositions(
      normalizedBody
    );


  if (
    positions.length === 0
  ) {

    if (seoDescription) {

      return escapeHtml(
        seoDescription.trim()
      );

    }


    return escapeHtml(
      createOpeningExcerpt(
        cleanBody
      )
    );

  }


  /* ========================================
     BUILD CANDIDATES
  ======================================== */

const candidates =
  positions.map(
    function (position) {

      return buildContextCandidate(
        cleanBody,
        position
      );

    }
  );


/* ========================================
   SCORE THE ACTUAL FINAL EXCERPTS
======================================== */

const scoredCandidates =
  candidates
    .map(
      function (candidate) {

        return scoreFinalExcerptCandidate(
          candidate
        );

      }
    )
    .filter(Boolean);


/*
  Safety fallback.
*/

if (
  scoredCandidates.length === 0
) {

  if (seoDescription) {

    return createOpeningExcerpt(
      seoDescription.trim()
    );

  }


  return escapeHtml(
    createOpeningExcerpt(
      cleanBody
    )
  );

}


/*
  MOST IMPORTANT:
  Compare concept coverage inside the actual
  final 22-word excerpts.

  SECONDARY:
  Use our existing prose-quality score when
  concept coverage is tied.
*/

scoredCandidates.sort(
  function (a, b) {

    /*
      PRIORITY 1

      Prefer excerpts that explain more
      concepts NOT already visible in the title.
    */

    if (
      a.unexplainedConceptCount !==
      b.unexplainedConceptCount
    ) {

      return (
        b.unexplainedConceptCount -
        a.unexplainedConceptCount
      );

    }


    /*
      PRIORITY 2

      Prefer greater overall concept coverage
      in the actual final 22-word excerpt.
    */

    if (
      a.finalCoverage.count !==
      b.finalCoverage.count
    ) {

      return (
        b.finalCoverage.count -
        a.finalCoverage.count
      );

    }


    /*
      PRIORITY 3

      When coverage is tied, prefer the
      excerpt containing the more distinctive
      technical concept(s).

      Example:

      IK10 beats a broad ordinary word such
      as "localized".
    */

    if (
      a.specificityScore !==
      b.specificityScore
    ) {

      return (
        b.specificityScore -
        a.specificityScore
      );

    }


    /*
      PRIORITY 4

      Finally use the existing prose-quality
      heuristic.
    */

    return (
      b.proseScore -
      a.proseScore
    );

  }
);


const bestScoredCandidate =
  scoredCandidates[0];


const bestCandidate =
  bestScoredCandidate.candidate;


const anchorVariant =
  bestScoredCandidate.anchorVariant;



  /*
    Safety fallback.
  */

  if (!anchorVariant) {

    if (seoDescription) {

      return escapeHtml(
        seoDescription.trim()
      );

    }


    return escapeHtml(
      createOpeningExcerpt(
        cleanBody
      )
    );

  }


  return createFixedContextExcerpt(
    bestCandidate.text,
    anchorVariant
  );
}


  /* ==========================================
     NORMAL DESCRIPTION
  ========================================== */

/* ==========================================
   CLEAN OPENING EXCERPT
========================================== */

function createOpeningExcerpt(content) {

  const cleanContent =
    cleanText(content);


  if (!cleanContent) {
    return "";
  }


  const words =
    cleanContent.split(/\s+/);


  const MAX_WORDS = 22;


  const excerpt =
    words
      .slice(
        0,
        MAX_WORDS
      )
      .join(" ");


  if (
    words.length >
    MAX_WORDS
  ) {

    return excerpt + "...";

  }


  return excerpt;
}


/* ==========================================
   FIND FIRST MEANINGFUL PARAGRAPH
========================================== */

function getFirstMeaningfulParagraph(content) {

  if (!content) {
    return "";
  }


  const parser =
    new DOMParser();


  const documentCopy =
    parser.parseFromString(
      String(content),
      "text/html"
    );


  /*
    Remove code and obvious UI/navigation
    elements before looking for paragraphs.
  */

  documentCopy
    .querySelectorAll(
      [
        "style",
        "script",
        "noscript",
        "svg",
        "template",
        "nav",
        ".breadcrumb-nav",
        ".anchor-links",
        ".back-link",
        ".contact-cta"
      ].join(",")
    )
    .forEach(function (element) {

      element.remove();

    });


  const paragraphs =
    Array.from(
      documentCopy.querySelectorAll("p")
    );


  /*
    Look for the first paragraph substantial
    enough to function as a useful description.
  */

  for (
    let i = 0;
    i < paragraphs.length;
    i += 1
  ) {

    const text =
      cleanText(
        paragraphs[i].textContent
      );


    /*
      Ignore tiny UI labels, captions,
      breadcrumbs, etc.
    */

    if (
      text.length >= 60 &&
      text.split(/\s+/).length >= 8
    ) {

      return text;

    }

  }


  /*
    Older pages may not contain useful <p>
    structure. Fall back to our universal
    cleaned-content system.
  */

  return "";
}
/* ==========================================
   NORMAL DESCRIPTION FOR TITLE MATCHES
========================================== */

function getNormalDescription(item) {

  /*
    ARTICLES

    First preference:
    Use the SEO meta description.

    This is generally the cleanest and most
    intentional summary of the page.
  */

  if (
    item.__typename === "Article"
  ) {


    if (
  item.seo &&
  item.seo.description &&
  item.seo.description.trim()
) {

  return createOpeningExcerpt(
    item.seo.description.trim()
  );

}


    /*
      Fallback:
      If an older article has no SEO
      description, try its first meaningful
      paragraph.
    */

    const meaningfulParagraph =
      getFirstMeaningfulParagraph(
        item.content
      );


    if (meaningfulParagraph) {

      return createOpeningExcerpt(
        meaningfulParagraph
      );

    }


    /*
      Final article fallback.
    */

    return createOpeningExcerpt(
      item.content || ""
    );

  }


  /*
    PAGES
  */

  if (
    item.__typename === "Page"
  ) {

    const meaningfulParagraph =
      getFirstMeaningfulParagraph(
        item.body
      );


    if (meaningfulParagraph) {

      return createOpeningExcerpt(
        meaningfulParagraph
      );

    }


    return createOpeningExcerpt(
      item.body || ""
    );

  }


  /*
    SHOPIFY PRODUCTS
  */

  if (
    item.__typename === "Product"
  ) {

    return createOpeningExcerpt(
      item.description || ""
    );

  }


  return "";
}


  /* ==========================================
     RESULT IMAGE
  ========================================== */

  function getItemImage(item) {

    if (
      item.__typename === "Article" &&
      item.image
    ) {

      return {
        url: item.image.url,
        alt:
          item.image.altText ||
          item.title ||
          ""
      };

    }


    if (
      item.__typename === "Product" &&
      item.featuredImage
    ) {

      return {
        url: item.featuredImage.url,
        alt:
          item.featuredImage.altText ||
          item.title ||
          ""
      };

    }


    return null;
  }


  /* ==========================================
     RESULT URL
  ========================================== */

  function getItemUrl(item) {

    return (
      item.onlineStoreUrl ||
      "#"
    );
  }


  /* ==========================================
     RENDER ONE RESULT
  ========================================== */

function renderResult(result) {

  const item =
    result.item;

  const url =
    getItemUrl(item);

  const image =
    getItemImage(item);


  let titleHtml;


  if (result.titleMatch) {

    titleHtml =
      highlightText(item.title);

  } else {

    titleHtml =
      escapeHtml(item.title);

  }


  let descriptionHtml;


if (
  result.hasBodyOnlyConcept
) {

const seoDescription =
  (
    item.seo &&
    item.seo.description
  )
    ? item.seo.description
    : "";


descriptionHtml =
  createContextualExcerpt(
    getItemBody(item),
    seoDescription,
    item.title || ""
  );

} else {

  /*
    The title already shows why this result
    matched, so keep the normal description
    clean rather than highlighting the query
    again.
  */

  descriptionHtml =
    escapeHtml(
      getNormalDescription(item)
    );

}


  let imageHtml = "";


  if (image) {

    imageHtml = `
      <div class="search-result-image">

        <img
          src="${escapeHtml(image.url)}"
          alt="${escapeHtml(image.alt)}"
          loading="lazy"
        >

      </div>
    `;

  }


  return `
    <div
      class="search-result-item clickable-search-result"
      data-url="${escapeHtml(url)}"
      tabindex="0"
      role="link"
      aria-label="View ${escapeHtml(item.title)}"
    >

      <div class="search-result-content">

        <h2 class="h3">
          <a href="${escapeHtml(url)}">
            ${titleHtml}
          </a>
        </h2>

        <p>
          ${descriptionHtml}
        </p>

      </div>

      ${imageHtml}

    </div>
  `;
}


  /* ==========================================
     TOTAL CUSTOMER PAGES
  ========================================== */

  function getTotalPages() {

    return Math.ceil(
      preparedResults.length /
      RESULTS_PER_PAGE
    );
  }


  /* ==========================================
     RENDER RESULT COUNT
  ========================================== */

  function renderResultCount() {

    if (!countContainer) {
      return;
    }


const count =
  preparedResults.length;


/* ========================================
   NO RESULTS
======================================== */

if (count === 0) {

  countContainer.textContent =
    `No results found for "${originalQuery}"`;

  return;
}


/* ========================================
   FUZZY-CORRECTED RESULTS
======================================== */

if (
  fuzzyDisplayCorrection.wasCorrected
) {

  countContainer.innerHTML = `
    <div class="search-correction-message">
      Showing results for
      <strong>
        "${escapeHtml(
          fuzzyDisplayCorrection.correctedQuery
        )}"
      </strong>
    </div>

    <div class="search-result-total">
      ${count}
      ${count === 1 ? "result" : "results"} found
    </div>
  `;

  return;
}


/* ========================================
   NORMAL RESULTS
======================================== */

countContainer.textContent =
  `${count} ${
    count === 1
      ? "result"
      : "results"
  } found for "${originalQuery}"`;


    if (count === 1) {

      countContainer.textContent =
        `1 result found for "${originalQuery}"`;

      return;
    }


    countContainer.textContent =
      `${count} results found for "${originalQuery}"`;
  }


  /* ==========================================
     RENDER CURRENT PAGE
  ========================================== */

  function renderCurrentPage() {

    if (!resultsContainer) {
      return;
    }


    const totalPages =
      getTotalPages();


if (preparedResults.length === 0) {

  resultsContainer.innerHTML = "";


      if (paginationContainer) {
        paginationContainer.innerHTML = "";
      }


      renderResultCount();

      return;
    }


    /*
      Ensure current page remains valid.
    */

    if (currentPage < 1) {
      currentPage = 1;
    }


    if (currentPage > totalPages) {
      currentPage = totalPages;
    }


    const startIndex =
      (currentPage - 1) *
      RESULTS_PER_PAGE;


    const endIndex =
      startIndex +
      RESULTS_PER_PAGE;


    const pageResults =
      preparedResults.slice(
        startIndex,
        endIndex
      );


    resultsContainer.innerHTML =
      pageResults
        .map(renderResult)
        .join("");


    renderResultCount();
    renderPagination();
  }


  /* ==========================================
     SCROLL BACK TO RESULTS
  ========================================== */

  function scrollToResults() {

    if (!resultsContainer) {
      return;
    }


    const top =
      resultsContainer
        .getBoundingClientRect()
        .top +
      window.pageYOffset -
      30;


    window.scrollTo({
      top: top,
      behavior: "smooth"
    });
  }


  /* ==========================================
     CHANGE CUSTOMER PAGE
  ========================================== */

  function goToPage(pageNumber) {

    const totalPages =
      getTotalPages();


    if (
      pageNumber < 1 ||
      pageNumber > totalPages
    ) {

      return;

    }


    currentPage =
      pageNumber;


    renderCurrentPage();
    scrollToResults();
  }


  /* ==========================================
     PAGINATION BUTTON
  ========================================== */

  function createPaginationButton(
    label,
    pageNumber,
    options = {}
  ) {

    const button =
      document.createElement("button");


    button.type = "button";
    button.className =
      "custom-search-page";


    if (options.active) {

      button.classList.add(
        "is-active"
      );

      button.setAttribute(
        "aria-current",
        "page"
      );

    }


    if (options.disabled) {

      button.disabled = true;

    }


    button.textContent =
      label;


    button.addEventListener(
      "click",
      function () {

        if (!button.disabled) {

          goToPage(pageNumber);

        }

      }
    );


    return button;
  }


  /* ==========================================
     PAGINATION ELLIPSIS
  ========================================== */

  function createPaginationEllipsis() {

    const span =
      document.createElement("span");


    span.className =
      "custom-search-pagination-ellipsis";


    span.textContent =
      "…";


    return span;
  }


  /* ==========================================
     RENDER PAGINATION
  ========================================== */

  function renderPagination() {

    if (!paginationContainer) {
      return;
    }


    paginationContainer.innerHTML = "";


    const totalPages =
      getTotalPages();


    if (totalPages <= 1) {
      return;
    }


    const wrapper =
      document.createElement("div");


    wrapper.className =
      "pagination custom-search-pagination";


    /*
      Previous
    */

    wrapper.appendChild(
      createPaginationButton(
        "Previous",
        currentPage - 1,
        {
          disabled:
            currentPage === 1
        }
      )
    );


    /*
      For a small number of pages,
      show every page number.
    */

    if (totalPages <= 7) {

      for (
        let page = 1;
        page <= totalPages;
        page += 1
      ) {

wrapper.appendChild(
  createPaginationButton(
    String(page),
    page,
    {
      active:
        page === currentPage,

      disabled:
        page === currentPage
    }
  )
);

      }

    } else {

      /*
        Larger result sets:

        1 ... 4 5 6 ... 20
      */

      const pagesToShow =
        new Set();


      pagesToShow.add(1);
      pagesToShow.add(totalPages);
      pagesToShow.add(currentPage);


      if (currentPage > 1) {
        pagesToShow.add(
          currentPage - 1
        );
      }


      if (currentPage < totalPages) {
        pagesToShow.add(
          currentPage + 1
        );
      }


      const sortedPages =
        Array.from(pagesToShow)
          .filter(function (page) {

            return (
              page >= 1 &&
              page <= totalPages
            );

          })
          .sort(function (a, b) {

            return a - b;

          });


      let previousPage = null;


      sortedPages.forEach(
        function (page) {

          if (
            previousPage !== null &&
            page - previousPage > 1
          ) {

            wrapper.appendChild(
              createPaginationEllipsis()
            );

          }


wrapper.appendChild(
  createPaginationButton(
    String(page),
    page,
    {
      active:
        page === currentPage,

      disabled:
        page === currentPage
    }
  )
);


          previousPage = page;

        }
      );

    }


    /*
      Next
    */

    wrapper.appendChild(
      createPaginationButton(
        "Next",
        currentPage + 1,
        {
          disabled:
            currentPage === totalPages
        }
      )
    );


    paginationContainer.appendChild(
      wrapper
    );
  }


  /* ==========================================
     LOADING STATE
  ========================================== */

  function showLoadingState() {

    if (!resultsContainer) {
      return;
    }


    resultsContainer.innerHTML = `
      <div class="search-loading">
        <p>
          Searching for
          <strong>${escapeHtml(originalQuery)}</strong>...
        </p>
      </div>
    `;


    if (paginationContainer) {

      paginationContainer.innerHTML = "";

    }

  }


  /* ==========================================
     ERROR STATE
  ========================================== */

  function showErrorState() {

    if (!resultsContainer) {
      return;
    }


    resultsContainer.innerHTML = `
      <div class="search-error">
        <p>
          We were unable to load the search results.
          Please try again.
        </p>
      </div>
    `;


    if (paginationContainer) {

      paginationContainer.innerHTML = "";

    }

  }


  /* ==========================================
     INITIALISE CUSTOM SEARCH
  ========================================== */

  async function initialiseCustomSearch() {

    try {

      showLoadingState();


      console.log(
        "===== CUSTOM SEARCH ====="
      );


      console.log(
        "Original query:",
        originalQuery
      );


console.log(
  "Optimized API variants:",
  getRetrievalQueryVariants(
    originalQuery
  )
);


      /*
        Retrieve candidate results from Shopify.
      */

      const candidates =
        await fetchAllCandidateResults();


      console.log(
        "Candidate results retrieved:",
        candidates.length
      );


      /*
        Filter out tag-only / unrelated results
        and rank title matches before body matches.
      */

      preparedResults =
        prepareResults(candidates);
        window.debugSearchResults = preparedResults;


      console.log(
        "Relevant title/body results:",
        preparedResults.length
      );


      console.log(
        "Prepared results:",
        preparedResults.map(
          function (result) {

            return {
              title:
                result.item.title,

              type:
                result.item.__typename,

              titleMatch:
                result.titleMatch,

              bodyMatch:
                result.bodyMatch,

              priority:
                result.priority
            };

          }
        )
      );


currentPage = 1;


if (resultsContainer) {

  /*
    Try to restore a previous search position.

    restoreSearchPosition() now tells us
    whether restoration actually happened.
  */

  const restored =
    restoreSearchPosition();


  /*
    If there was no valid state for THIS exact
    search, render normally.

    This prevents the page from remaining stuck
    on "Searching for..." because an unrelated
    old sessionStorage entry exists.
  */

  if (!restored) {

    renderCurrentPage();

  }

} else {

  console.log(
    "Custom search results container not found. Search data was retrieved successfully, but nothing was rendered."
  );

}


    } catch (error) {

      console.error(
        "Custom search failed:",
        error
      );


      showErrorState();

    }

  }

  
/* ==========================================
   CLICKABLE SEARCH RESULTS
========================================== */

document.addEventListener("click", function (event) {

  const result =
    event.target.closest(
      ".clickable-search-result"
    );


  if (!result) {
    return;
  }


  /*
    Allow normal browser behaviour when the
    visitor directly clicks an existing link.
  */

  if (event.target.closest("a")) {
    return;
  }


  const url =
    result.getAttribute("data-url");


  if (!url) {
    return;
  }


  saveSearchPosition();

  window.location.href = url;

});


/* ==========================================
   KEYBOARD ACCESSIBILITY
========================================== */

document.addEventListener("keydown", function (event) {

  const result =
    event.target.closest(
      ".clickable-search-result"
    );


  if (!result) {
    return;
  }


  if (
    event.key !== "Enter" &&
    event.key !== " "
  ) {
    return;
  }


  event.preventDefault();


  const url =
    result.getAttribute("data-url");


  if (!url) {
    return;
  }


  saveSearchPosition();

  window.location.href = url;

});

/* ==========================================
   SAVE SEARCH POSITION
========================================== */

function saveSearchPosition() {

  const state = {

    /*
      Store the exact search URL so we only
      restore this position for the same search.
    */

    searchUrl:
      window.location.pathname +
      window.location.search,

    scrollY:
      window.scrollY,

    page:
      currentPage,

    savedAt:
      Date.now()

  };


  sessionStorage.setItem(
    "customSearchReturnState",
    JSON.stringify(state)
  );

}

/* ==========================================
   RESTORE SEARCH POSITION
========================================== */

function restoreSearchPosition() {

  const storedState =
    sessionStorage.getItem(
      "customSearchReturnState"
    );


  /*
    Nothing to restore.
  */

  if (!storedState) {

    return false;

  }


  let state;


  try {

    state =
      JSON.parse(
        storedState
      );

  } catch (error) {

    sessionStorage.removeItem(
      "customSearchReturnState"
    );


    return false;

  }


  const currentSearchUrl =
    window.location.pathname +
    window.location.search;


  /*
    Only restore when returning to the EXACT
    search that the visitor previously left.

    An old state belonging to another search
    must not prevent normal rendering.
  */

  if (
    state.searchUrl !==
    currentSearchUrl
  ) {

    sessionStorage.removeItem(
      "customSearchReturnState"
    );


    return false;

  }


  /*
    Don't retain an old position indefinitely.

    30 minutes is more than enough for normal:

    search
      ->
    product
      ->
    browser back
  */

  const MAX_STATE_AGE =
    30 * 60 * 1000;


  if (
    !state.savedAt ||
    Date.now() -
      state.savedAt >
      MAX_STATE_AGE
  ) {

    sessionStorage.removeItem(
      "customSearchReturnState"
    );


    return false;

  }


  /*
    Restore the locally paginated result page.
  */

  if (
    state.page &&
    Number.isInteger(
      state.page
    )
  ) {

    currentPage =
      state.page;

  }


  /*
    Render the correct result page first.
  */

  renderCurrentPage();


  /*
    Then restore the previous vertical
    position once layout has begun settling.
  */

  setTimeout(
    function () {

      window.scrollTo({
        top:
          state.scrollY || 0,

        behavior:
          "auto"
      });


      /*
        State has served its purpose.

        Remove it so a later normal visit to
        this same search does not unexpectedly
        jump.
      */

      sessionStorage.removeItem(
        "customSearchReturnState"
      );

    },
    150
  );


  /*
    Tell initialiseCustomSearch() that this
    function successfully handled rendering.
  */

  return true;
}



/* ==========================================
   START SEARCH
========================================== */

initialiseCustomSearch();



});



/* CODE IS COMPLETE */

